/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Modal, Checkbox, Popup, List, Message, Loader, Radio, Icon, Form
} from 'semantic-ui-react';
import Dropzone from 'react-dropzone';
import { observer, inject } from 'mobx-react';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import WithRouter from '../Extensions/WithRouter';
import ClarLoader from '../Loader/Loader';
import api from '../../api';
import userPic from '../../images/components/profile/profile_icon_big.png';
import ChangePasswordModal from '../Modal/ChangePasswordModal';
import ChangeRecoveryEmailModal from '../Modal/ChangeRecoveryEmailModal';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userName: '',
      email: '',
      viewMode: '',
      permission: '',
      mainPage: {
        main: '',
        sub: '',
      },
      isSetResult: false,
      isChangeName: false,
      isChangePw: false,
      isChangeImg: false,
      createdDate: '',
      lastAccessed: '',
      assignedGroups: [],
      assignedProjects: [],
      memberList: [],
      projectMemberList: {
        group_list: [],
        member_list: [],
      },
      popupStatus: {
        memberPopup: false,
        projectPopup: false,
      },
      prevSubStatus: '',
      file: {
        error: false,
        value: '',
        errorMsg: '',
        preview: null,
        image: null,
      },
      activeIndex: '',
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      isOpenMCP: false,
      visible: false,
      profileImgUrl: '',
      authorizedIps: 'all',
      selectedIps: '',
      isIpChangeable: false,
      ipsError: '',
      isShowRecoveryEmail: false,
      recoveryEmail: '',
      isOpenMCR: false,
      pageLimit: 10,
      selectedLocale: 'en',
    };
    this.onDrop = this.onDrop.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleMainPageChange = this.handleMainPageChange.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.handleResetRecoveryEmail = this.handleResetRecoveryEmail.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handlePasswordModal = this.handlePasswordModal.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleIpRadioChange = this.handleIpRadioChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleLocaleChange = this.handleLocaleChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.fetchUserProfile();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isLoading } = this.state;
    const { location } = this.props;

    if (isLoading !== prevState.isLoading) {
      this.setProfileImageURL();
    }
    if (location.pathname !== prevProps.location.pathname) {
      this.setState({
        file: {
          error: false,
          value: '',
          errorMsg: '',
          preview: null,
          image: null,
        },
        ipsError: '',
      });
    }
  }

  handleDismiss = () => {
    this.setState({ visible: false });
  };

  handleSave(e) {
    e.preventDefault();
    const objectError = {};
    const {
      authorizedIps, selectedIps, isIpChangeable, userName, file, viewMode, mainPage, pageLimit, selectedLocale
    } = this.state;
    const { t } = this.props;
    if (!userName) {
      objectError.name = {
        error: true,
        errorMsg: 'required name',
      };
    } else {
      objectError.name = {
        error: false,
      };
    }
    if (!objectError.name.error) {
      const formData = new FormData();
      let ips;
      formData.append('name', userName);
      if (file.image) {
        formData.append('image', file.image);
      }
      formData.append('view_mode', viewMode);
      formData.append('main_page', JSON.stringify(mainPage));
      formData.append('page_limit', pageLimit);

      if (authorizedIps === 'specific' && isIpChangeable) {
        if (selectedIps.trim().length === 0) {
          return this.setState({
            ipsError: t('profile.error.one_ip_address'),
          });
        }
        const ipsArray = this.separateString(selectedIps);
        const regexIpv = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
        let i = 0;
        for (i; i < ipsArray.length; i++) {
          if (!regexIpv.test(ipsArray[i])) {
            return this.setState({
              ipsError: t('profile.error.invalid_ip_address'),
            });
          }
        }
        ips = ipsArray;
      } else {
        ips = [];
      }
      if (ips.length === 0) {
        formData.append('authorized_ips', []);
      } else {
        let j = 0;
        for (j; j < ips.length; j++) {
          formData.append('authorized_ips[]', ips[j]);
        }
      }
      formData.append('locale', selectedLocale);

      this.postForm(formData);
    }
  }

  handleResetPassword() {
    this.setState({
      isOpenMCP: true,
    });
  }

  handleResetRecoveryEmail() {
    this.setState({
      isOpenMCR: true,
    });
  }

  handlePopupClose() {
    const status = {
      projectPopup: false,
      memberPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  handleNameChange(e) {
    this.setState({
      userName: e.target.value,
    });
  }

  handlePageChange(e) {
    const { dataset } = e.currentTarget;

    this.setState({
      mainPage: {
        main: 'result',
        sub: dataset.id,
      },
    });
  }

  handleMainPageChange() {
    const { isSetResult, mainPage, prevSubStatus } = this.state;

    const nextIsSetResult = !isSetResult;

    if (nextIsSetResult) {
      const targetSub = prevSubStatus || 'overview';

      this.setState({
        isSetResult: true,
        mainPage: {
          main: 'result',
          sub: targetSub,
        },
        visible: false,
      });
    } else {
      const currentSub = mainPage.sub;

      this.setState({
        isSetResult: false,
        mainPage: {
          main: 'dashboard',
          sub: '',
        },
        prevSubStatus: currentSub,
        visible: true,
      });
    }
  }

  handleCloseAlert() {
    this.setState({
      modalAlert: false,
    });
  }

  handlePasswordModal() {
    this.setState({
      isOpenMCP: false,
    });
  }

  handleRadioChange(e, { value }) {
    this.setState({
      viewMode: value,
    });
  }

  handleIpRadioChange(e, { value }) {
    this.setState({
      authorizedIps: value,
    });
  }

  handleInputChange(e) {
    this.setState({
      selectedIps: e.target.value,
      ipsError: '',
    });
  }

  handlePageSizeChange(e, { value }) {
    const { pageLimit } = this.state;

    if (value === pageLimit) {
      return;
    }
    this.setState({
      pageLimit: value,
    });
  }

  handleLocaleChange(e, { value }) {
    this.setState({
      selectedLocale: value,
    });
  }

  onDrop(files) {
    this.setState({
      file: {
        preview: URL.createObjectURL(files[0]),
        image: files[0],
      },
      profileImgUrl: URL.createObjectURL(files[0]),
    });
  }

  getSGroupMemberDetail = (groupId) => {
    const status = {
      projectPopup: false,
      memberPopup: true,
    };
    api
      .getSGroupMemberDetail(groupId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: groupId,
          memberList: data.member_list,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  getSProjectMemberDetail = (projectId) => {
    const status = {
      projectPopup: true,
      memberPopup: false,
    };
    api
      .getSProjectMemberDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          projectMemberList: data,
          memberList: [],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  setProfileImageURL = () => {
    const { isLoading, file } = this.state;
    const { state } = this.props;
    let baseUrl = '//'.concat(location.hostname);
    let url;

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    if (!isLoading) {
      url = file.preview || baseUrl.concat(state.user.image_medium, '?', new Date().getTime()) || userPic;
    } else {
      url = userPic;
    }

    this.setState({
      profileImgUrl: url,
    });
  };

  postForm(data) {
    const { selectedLocale } = this.state;
    const { state, t, i18n } = this.props;
    this.setState({
      modalAlert: true,
      isLoader: true,
    });
    api
      .setUserProfile(data)
      .then(() => {
        let locale;
        if (selectedLocale === 'ko') {
          locale = 'kr';
        } else if (selectedLocale === 'ja') {
          locale = 'ja';
        } else {
          locale = 'en';
        }
        i18n.changeLanguage(locale);
        localStorage.setItem('i18nextLng', locale);
        this.setState(
          {
            isLoader: false,
            modalAlertMsg: t('profile.message.update_success'),
            modalAlertTitle: t('modal.title.notice'),
          },
          () => {
            this.fetchUserProfile();
          }
        );
        api.getUserProfile(this.access_token).then((rsp) => {
          state.user.setUserProfile(rsp.response);
          state.user.setLocaleParams(selectedLocale);
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === 'incorrect_password') {
          this.setState({
            isLoader: false,
            modalAlertMsg: o.data.error_description,
            modalAlertTitle: t('modal.title.attention'),
          });
        } else if (o.error === '422-225') {
          this.setState({
            isLoader: false,
            modalAlertMsg: t('profile.error.error_422_225'),
            modalAlertTitle: t('modal.title.attention'),
          });
        } else if (o.error === '422-226') {
          this.setState({
            isLoader: false,
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: t('profile.error.invalid_ip_address'),
          });
        } else if (o.error === '422-375') {
          this.setState({
            isLoader: false,
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: t('profile.error.error_422_375'),
          });
        } else {
          this.setState({
            isLoader: false,
            modalAlertMsg: t('profile.error.error_422_225'),
            modalAlertTitle: t('modal.title.attention'),
          }, () => {
            api.getUserProfile(this.access_token).then((rsp) => {
              state.user.setUserProfile(rsp.response);
            });
          });
        }
      });
  }

  fetchUserProfile() {
    const { i18n } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .fetchUserProfile()
        .then((response) => {
          const res = response.response;

          if (res.main_page.main.indexOf('result') > -1) {
            this.setState({
              isSetResult: true,
            });
          } else {
            this.setState({
              isSetResult: false,
            });
          }

          let authorizedIps;
          let selectedIps;
          if (res.authorized_ips.length === 0) {
            authorizedIps = 'all';
            selectedIps = '';
          } else {
            authorizedIps = 'specific';
            let i = 0;
            for (i; i < res.authorized_ips.length; i++) {
              if (i === 0) {
                selectedIps = res.authorized_ips[i];
              } else {
                selectedIps = `${selectedIps},${res.authorized_ips[i]}`;
              }
            }
          }

          const localeData = res.user_locale.filter((item) => {
            return item.selected === true;
          });

          let locale;
          if (localeData[0].locale === 'ko') {
            locale = 'kr';
          } else if (localeData[0].locale === 'ja') {
            locale = 'ja';
          } else {
            locale = 'en';
          }

          this.setState({
            //id: res.id,
            userName: res.user_name,
            email: res.email,
            permission: res.permission,
            mainPage: res.main_page,
            isChangeName: res.is_change_user_name_allowed,
            isChangePw: res.is_change_password_allowed,
            isChangeImg: res.is_change_image_allowed,
            isIpChangeable: res.is_change_authorized_ip_allowed,
            createdDate: res.created,
            lastAccessed: res.last_accessed,
            assignedGroups: res.assigned_groups,
            assignedProjects: res.assinged_projects,
            viewMode: res.view_mode,
            isLoading: false,
            authorizedIps,
            selectedIps,
            isShowRecoveryEmail: res.is_show_recovery_email,
            recoveryEmail: res.recovery_email,
            pageLimit: res.page_limit,
            selectedLocale: localeData[0].locale,
          }, () => {
            i18n.changeLanguage(locale);
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  closeModal(string) {
    if (string === 'refresh') {
      this.setState({
        isOpenMCR: false,
      }, () => {
        this.fetchUserProfile();
      });
    } else {
      this.setState({
        isOpenMCR: false,
      });
    }
  }

  separateString(value) {
    const separatedArray = [];
    const originalString = value.replace(/ /g, '');
    let previousIndex = 0;
    let i = 0;
    for (i; i < originalString.length; i++) {
      if (originalString[i] === ',') {
        const separated = originalString.slice(previousIndex, i);
        separatedArray.push(separated);
        previousIndex = i + 1;
      }
    }
    separatedArray.push(originalString.slice(previousIndex, i));
    return separatedArray;
  }

  render() {
    const {
      isChangeName,
      isChangePw,
      isChangeImg,
      isOpenMCP,
      isOpenMCR,
      assignedGroups,
      assignedProjects,
      createdDate,
      lastAccessed,
      permission,
      email,
      userName,
      isSetResult,
      mainPage,
      popupStatus,
      activeIndex,
      isLoading,
      profileImgUrl,
      viewMode,
      isIpChangeable,
      authorizedIps,
      selectedIps,
      isShowRecoveryEmail,
      recoveryEmail,
      pageLimit,
      ipsError,
      visible,
      memberList,
      projectMemberList,
      modalAlert,
      modalAlertTitle,
      modalAlertMsg,
      isLoader,
      selectedLocale,
    } = this.state;
    const { t } = this.props;

    const ipsErrorClass = ipsError !== '' ? 'show' : '';

    const renderIfReady = (element) => {
      return !isLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('list.title.loading')}
        </Loader>
      );
    };

    const options = [
      { key: 10, text: 10, value: 10 },
      { key: 20, text: 20, value: 20 },
      { key: 40, text: 40, value: 40 },
      { key: 80, text: 80, value: 80 },
    ];

    return (
      <div className="contents">
        <div className="content">
          <div className="profile_content">
            <h2>{t('header.profile')}</h2>
            {
              renderIfReady(
                <div className="profile_content_area">
                  <div className="user_card">
                    {isChangeImg ? (
                      <Dropzone
                        onDrop={this.onDrop}
                        //accept="image/*"
                      >
                        {({ getRootProps, getInputProps }) => {
                          return (
                            <div {...getRootProps({ className: 'user_avata' })}>
                              <input {...getInputProps()} />
                              <img
                                className="profileImg"
                                src={profileImgUrl}
                                role="presentation"
                                style={{ cursor: 'pointer' }}
                                alt=""
                              />
                            </div>
                          );
                        }}
                      </Dropzone>
                    ) : (
                      <Dropzone
                        //accept="image/*"
                        style={{ pointerEvents: 'none' }}
                        disabled
                      >
                        {({ getRootProps, getInputProps }) => {
                          return (
                            <div {...getRootProps({ className: 'user_avata' })}>
                              <input {...getInputProps()} />
                              <img
                                className="profileImg"
                                src={profileImgUrl}
                                role="presentation"
                                alt=""
                              />
                            </div>
                          );
                        }}
                      </Dropzone>
                    )}
                    <div className="item">
                      <p className="label">{t('modal.title.user_name')}</p>
                      <p className="value">
                        <input
                          type="text"
                          placeholder="User Name"
                          value={userName}
                          onChange={this.handleNameChange}
                          disabled={!isChangeName}
                        />
                      </p>
                    </div>
                    <div className="item">
                      <p className="label">{t('modal.title.password')}</p>
                      <p className="value">
                        {isChangePw ? (
                          <a
                            className="button"
                            style={{ cursor: 'pointer' }}
                            onClick={this.handleResetPassword}
                            onKeyUp={this.handleResetPassword}
                          >
                            {t('modal.title.change_password')}
                          </a>
                        ) : (
                          <a
                            className="button"
                            style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                          >
                            {t('modal.title.change_password')}
                          </a>
                        )}
                      </p>
                    </div>
                    <div className="item">
                      <p className="label">{t('modal.title.email')}</p>
                      <p className="value">{this.convertToString(email)}</p>
                    </div>
                    {
                      isShowRecoveryEmail
                      && (
                        <div className="item">
                          <p className="label">
                            {t('profile.title.recovery_email')}
                            <Popup
                              trigger={<Icon name="question circle outline" style={{ color: '#7434fe' }} />}
                              content={t('login.message.set_email_address')}
                              position="top left"
                              size="small"
                              className="question"
                            />
                          </p>
                          <p className="value">{recoveryEmail}</p>
                        </div>
                      )
                    }
                    {
                      isShowRecoveryEmail
                      && (
                        <div className="item">
                          <p className="value">
                            <a
                              className="button"
                              style={{ cursor: 'pointer' }}
                              onClick={this.handleResetRecoveryEmail}
                              onKeyUp={this.handleResetRecoveryEmail}
                            >
                              {t('profile.title.change_recovery_email')}
                            </a>
                          </p>
                        </div>
                      )
                    }
                  </div>
                  <div className="user_info">
                    <Form>
                      <Form.Group widths="equal">
                        <Form.Input fluid label={t('profile.title.permission')} value={permission} readOnly />
                        <Form.Input fluid label={t('profile.title.create_date')} value={createdDate} readOnly />
                        <Form.Input fluid label={t('profile.title.last_accessed_date')} value={lastAccessed} readOnly />
                        <Form.Field>
                          <label>{t('profile.title.default_page_size')}</label>
                          <Form.Dropdown
                            options={options}
                            selection
                            defaultValue={pageLimit}
                            onChange={this.handlePageSizeChange}
                          />
                        </Form.Field>
                      </Form.Group>
                    </Form>
                    <Form>
                      <Form.Field>
                        <label>{t('profile.title.main_page')}</label>
                        <Message
                          className={cx({
                            show: visible,
                          })}
                          warning
                          onDismiss={this.handleDismiss}
                          size="tiny"
                        >
                          <Message.Header>{t('modal.title.notice')}</Message.Header>
                          <p>{t('profile.message.main_page_uncheck')}</p>
                        </Message>
                      </Form.Field>
                      <Form.Field>
                        <Checkbox
                          className="set_result"
                          checked={isSetResult}
                          onChange={this.handleMainPageChange}
                          label={t('profile.message.set_result_menu')}
                          style={{ marginBottom: '5px', fontSize: '12px' }}
                        />
                      </Form.Field>
                      <Form.Field>
                        <div className="user_info_item_content">
                          {isSetResult ? (
                            <div className="switch button_5">
                              <a
                                className={cx({
                                  checked: mainPage.sub.indexOf('overview') > -1,
                                })}
                                data-id="overview"
                                onClick={this.handlePageChange}
                                onKeyUp={this.handlePageChange}
                              >
                                {t('project.menu.overview')}
                              </a>
                              <a
                                className={cx({
                                  checked: mainPage.sub.indexOf('component') > -1,
                                })}
                                data-id="component"
                                onClick={this.handlePageChange}
                                onKeyUp={this.handlePageChange}
                              >
                                {t('project.menu.component')}
                              </a>
                              <a
                                className={cx({
                                  checked: mainPage.sub.indexOf('security') > -1,
                                })}
                                data-id="security"
                                onClick={this.handlePageChange}
                                onKeyUp={this.handlePageChange}
                              >
                                {t('project.menu.security')}
                              </a>
                              <a
                                className={cx({
                                  checked: mainPage.sub.indexOf('license') > -1,
                                })}
                                data-id="license"
                                onClick={this.handlePageChange}
                                onKeyUp={this.handlePageChange}
                              >
                                {t('project.menu.license')}
                              </a>
                              <a
                                className={cx({
                                  checked: mainPage.sub.indexOf('policy') > -1,
                                })}
                                data-id="policy"
                                onClick={this.handlePageChange}
                                onKeyUp={this.handlePageChange}
                              >
                                {t('project.menu.policy')}
                              </a>
                            </div>
                          ) : (
                            <div className="switch button_5 disable">
                              <a>{t('project.menu.overview')}</a>
                              <a>{t('project.menu.component')}</a>
                              <a>{t('project.menu.security')}</a>
                              <a>{t('project.menu.license')}</a>
                              <a>{t('project.menu.policy')}</a>
                            </div>
                          )}
                        </div>
                      </Form.Field>
                    </Form>
                    <Form>
                      <Form.Group widths="equal">
                        <Form.Field stlye="radio_inline_wrap">
                          <label>{t('profile.title.view_mode')}</label>
                          <div className="radio_inline">
                            <Radio
                              label={t('profile.title.card_view')}
                              value="card"
                              checked={viewMode === 'card'}
                              onChange={this.handleRadioChange}
                            />
                            <Radio
                              label={t('profile.title.list_view')}
                              value="list"
                              checked={viewMode === 'list'}
                              onChange={this.handleRadioChange}
                            />
                          </div>
                        </Form.Field>
                        <Form.Field stlye="radio_inline_wrap">
                          <label>{t('system.language.settings')}</label>
                          <div className="radio_inline">
                            <Radio
                              label="한국어"
                              value="ko"
                              checked={selectedLocale === 'ko'}
                              onChange={this.handleLocaleChange}
                            />
                            <Radio
                              label="English"
                              value="en"
                              checked={selectedLocale === 'en'}
                              onChange={this.handleLocaleChange}
                            />
                            <Radio
                              label="日本語"
                              value="ja"
                              checked={selectedLocale === 'ja'}
                              onChange={this.handleLocaleChange}
                            />
                          </div>
                        </Form.Field>
                      </Form.Group>
                    </Form>
                    {
                      isIpChangeable
                      && (
                        <div className="user_info_item_wrap">
                          <div className="user_info_item left">
                            <h3>{t('profile.title.authorize_user_ip')}</h3>
                            <div className="user_info_item_content">
                              <div className="inline_radio">
                                <Radio
                                  label={t('profile.title.all_ip')}
                                  value="all"
                                  checked={authorizedIps === 'all'}
                                  onChange={this.handleIpRadioChange}
                                />
                                <Radio
                                  label={t('profile.title.specific_ip')}
                                  value="specific"
                                  checked={authorizedIps === 'specific'}
                                  onChange={this.handleIpRadioChange}
                                />
                              </div>
                            </div>
                          </div>
                          {
                            authorizedIps === 'specific'
                          && (
                            <div className="user_info_item right">
                              <h3>&nbsp;</h3>
                              <div className="user_info_item_content" style={{ position: 'relative' }}>
                                <Popup
                                  trigger={<Icon name="question circle outline" />}
                                  content={t('profile.message.multiple_ip_addr')}
                                  position="top left"
                                  size="small"
                                  className="question"
                                />
                                <input
                                  type="text"
                                  value={selectedIps}
                                  disabled={!isIpChangeable}
                                  placeholder={t('profile.title.authorized_ip_addr')}
                                  onChange={this.handleInputChange}
                                />
                                <div
                                  className={`error ${ipsErrorClass}`}
                                  style={{
                                    marginTop: '6px',
                                    marginLeft: '5px',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    color: '#ef4136',
                                  }}
                                >
                                  {ipsError}
                                </div>
                              </div>
                            </div>
                          )
                          }
                        </div>
                      )
                    }
                    <div className="user_info_item_wrap">
                      <div className="user_info_item">
                        <h3>
                          {t('settings.list.assigned_group')}
                          (
                          {assignedGroups.length}
                          )
                        </h3>
                        <div className="user_info_item_content">
                          <div className="user_info_table_wrap">
                            <table className="user_info_table" style={{ tableLayout: 'fixed' }}>
                              <colgroup>
                                <col style={{ width: '60%' }} />
                                <col style={{ width: '20%' }} />
                                <col style={{ width: '20%' }} />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th className="tal">{t('settings.list.group_name')}</th>
                                  <th className="tar">{t('settings.list.group_member')}</th>
                                  <th className="tac">
                                    {t('modal.title.assigned')}
                                  </th>
                                </tr>
                              </thead>
                            </table>
                            <div>
                              <Scrollbars
                                renderTrackHorizontal={() => {
                                  return <div />;
                                }}
                                renderThumbHorizontal={() => {
                                  return <div />;
                                }}
                                autoHeight
                                autoHeightMax={300}
                                ///ref="setGroupListScrollRef"
                              >
                                {assignedGroups.map((list) => {
                                  return (
                                    <table className="user_info_table" key={list.id}>
                                      <colgroup>
                                        <col style={{ width: '60%' }} />
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '20%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr key={list.id}>
                                          <td className="tal">{list.name}</td>
                                          {list.member_count === 0 ? (
                                            <td className="tar">{list.member_count}</td>
                                          ) : (
                                            <td className="tar">
                                              <Popup
                                                trigger={(
                                                  <span style={{ cursor: 'pointer' }}>
                                                    {list.member_count}
                                                  </span>
                                                )}
                                                on="click"
                                                style={{ marginLeft: '-14px' }}
                                                hideOnScroll
                                                position="bottom left"
                                                open={popupStatus.memberPopup && activeIndex === list.id}
                                                onOpen={() => {
                                                  return this.getSGroupMemberDetail(list.id);
                                                }}
                                                onClose={this.handlePopupClose}
                                              >
                                                <List>
                                                  {memberList.map((item) => {
                                                    return (
                                                      <List.Item key={item.toString()}>
                                                        <List.Icon name="user" />
                                                        <List.Content>{item}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })}
                                                </List>
                                              </Popup>
                                            </td>
                                          )}
                                          <td className="tac">{list.assigned}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  );
                                })}
                              </Scrollbars>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="user_info_item_wrap">
                      <div className="user_info_item">
                        <h3>
                          {t('settings.list.assigned_project')}
                          (
                          {assignedProjects.length}
                          )
                        </h3>
                        <div className="user_info_item_content">
                          <div className="user_info_table_wrap">
                            <table className="user_info_table" style={{ tableLayout: 'fixed' }}>
                              <colgroup>
                                <col style={{ width: '30%' }} />
                                <col style={{ width: '16.6%' }} />
                                <col style={{ width: '16.6%' }} />
                                <col style={{ width: '16.6%' }} />
                                <col style={{ width: '20%' }} />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th className="tal">{t('settings.list.project_name')}</th>
                                  <th className="tar">{t('modal.title.project_member')}</th>
                                  <th className="tac">{t('modal.title.project_owner')}</th>
                                  <th className="tac">{t('modal.title.assigned_to')}</th>
                                  <th className="tac">{t('modal.title.assigned')}</th>
                                </tr>
                              </thead>
                            </table>
                            <div>
                              <Scrollbars
                                renderTrackHorizontal={() => {
                                  return <div />;
                                }}
                                renderThumbHorizontal={() => {
                                  return <div />;
                                }}
                                autoHeight
                                autoHeightMax={300}
                              >
                                {assignedProjects.map((list) => {
                                  return (
                                    <table className="user_info_table" key={list.id}>
                                      <colgroup>
                                        <col style={{ width: '30%' }} />
                                        <col style={{ width: '16.6%' }} />
                                        <col style={{ width: '16.6%' }} />
                                        <col style={{ width: '16.6%' }} />
                                        <col style={{ width: '20%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tal">{list.name}</td>
                                          {list.member_count === 0 ? (
                                            <td className="tar">{list.member_count}</td>
                                          ) : (
                                            <td className="tar">
                                              <Popup
                                                trigger={(
                                                  <span style={{ cursor: 'pointer' }}>
                                                    {list.member_count}
                                                  </span>
                                                )}
                                                on="click"
                                                style={{ marginLeft: '-14px' }}
                                                hideOnScroll
                                                position="bottom left"
                                                open={
                                                  popupStatus.projectPopup
                                                  && activeIndex === list.id
                                                }
                                                onOpen={() => {
                                                  return this.getSProjectMemberDetail(list.id);
                                                }}
                                                onClose={this.handlePopupClose}
                                              >
                                                <List>
                                                  {projectMemberList.group_list.length !== 0 ? (
                                                    <List.Item
                                                      style={{ fontWeight: 'normal', fontSize: '12px' }}
                                                    >
                                                      <List.Header style={{ margin: '0 0 5px 0' }}>
                                                        {t('settings.list.group')}
                                                        (
                                                        {projectMemberList.group_list.length}
                                                        )
                                                      </List.Header>
                                                      <List.List>
                                                        {projectMemberList.group_list.map(
                                                          (group) => {
                                                            return (
                                                              <List.Item key={group.toString()}>
                                                                <List.Icon name="group" />
                                                                <List.Content>{group}</List.Content>
                                                              </List.Item>
                                                            );
                                                          }
                                                        )}
                                                      </List.List>
                                                    </List.Item>
                                                  ) : null}
                                                  {projectMemberList.member_list.length !== 0 ? (
                                                    <List.Item
                                                      style={{ fontWeight: 'normal', fontSize: '12px' }}
                                                    >
                                                      <List.Header style={{ margin: '0 0 5px 0' }}>
                                                        {t('settings.list.User')}
                                                        (
                                                        {projectMemberList.member_list.length}
                                                        )
                                                      </List.Header>
                                                      <List.List>
                                                        {projectMemberList.member_list.map(
                                                          (member) => {
                                                            return (
                                                              <List.Item key={member.toString()}>
                                                                <List.Icon name="user" />
                                                                <List.Content>{member}</List.Content>
                                                              </List.Item>
                                                            );
                                                          }
                                                        )}
                                                      </List.List>
                                                    </List.Item>
                                                  ) : null}
                                                </List>
                                              </Popup>
                                            </td>
                                          )}
                                          <td className="tac">{list.owner}</td>
                                          <td className="tac">{list.assigned_to}</td>
                                          <td className="tac">{list.assigned}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  );
                                })}
                              </Scrollbars>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            <div className="profile_bottom">
              <a className="save" style={{ cursor: 'pointer' }} onClick={this.handleSave} onKeyUp={this.handleSave}>
                {t('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <Modal open={modalAlert} onClose={this.handleCloseAlert}>
          {isLoader ? (
            <ClarLoader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{modalAlertTitle}</h2>
                  <p className="text">{modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a onClick={this.handleCloseAlert} onKeyUp={this.handleCloseAlert} className="center_button">
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <ChangePasswordModal
          isOpenMCP={isOpenMCP}
          closeModal={this.handlePasswordModal}
          translate={t}
        />
        <ChangeRecoveryEmailModal
          isOpenMCR={isOpenMCR}
          closeModal={this.closeModal}
          translate={t}
        />
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(UserProfile))));
